module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/event/event.component.scss
// module id = ./src/app/routes/event/event.component.scss
// module chunks = 9